import { render, staticRenderFns } from "./TonosTab.vue?vue&type=template&id=00fabf02&scoped=true&"
import script from "./TonosTab.vue?vue&type=script&lang=js&"
export * from "./TonosTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fabf02",
  null
  
)

export default component.exports